import { ErrorMessage, useFormikContext } from 'formik'
import { FC } from 'react'
import { Form } from 'rsuite'
import './formikErrorMessage.scss'

export type FormErrorMessagePlacement =
  | 'bottomStart'
  | 'bottomEnd'
  | 'topStart'
  | 'topEnd'
  | 'leftStart'
  | 'leftEnd'
  | 'rightStart'
  | 'rightEnd'

type Props = {
  name: string,
  placement?: FormErrorMessagePlacement
}
const FormikErrorMessage: FC<Props> = ({ name, placement }: Props) => {
  const formikContext = useFormikContext()

  if (!formikContext) {
    return null
  }

  const renderFormError = (errorMessage: string) => (
    <Form.ErrorMessage
      show={!!errorMessage}
      placement={placement ?? 'bottomStart'}
    >
      {errorMessage}
    </Form.ErrorMessage>
  )

  return (
    <div>
      <ErrorMessage name={name} render={renderFormError} />
    </div>
  )
}
export default FormikErrorMessage
